var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "floL" }, [
      _c(
        "label",
        { attrs: { for: "file" + _vm.resIdx + "_" + _vm.question.sq_code } },
        [
          _c("em", { staticClass: "disIb" }, [
            _vm._v(_vm._s(_vm.question.title)),
            _c("span", { staticClass: "ico-must-astar" })
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.existFileData
        ? _c("input", {
            ref: "attachment",
            staticStyle: { display: "none" },
            attrs: {
              type: "file",
              accept: ".png, .jpg, .pdf",
              name: "file" + _vm.resIdx + "_" + _vm.question.sq_code,
              id: "file" + _vm.resIdx + "_" + _vm.question.sq_code,
              disabled: _vm.disabled
            },
            on: { change: _vm.uploadAttachment }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "floR txtR" }, [
      _c("div", { staticClass: "NCAcmi_familyN_fileWrap" }, [
        _c(
          "span",
          {
            staticClass: "fntP NCAcmi_familyN_file",
            class: { disabled: _vm.existFileData || _vm.disabled },
            style: {
              cursor: _vm.existFileData || _vm.disabled ? "default" : "pointer"
            },
            on: { click: _vm.clickUploadButton }
          },
          [_vm._v("파일 업로드")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "posRe" }, [
          _c(
            "label",
            {
              staticClass: "NCAcmi_familyN_fileBox marTS NCAcmiFile_remove",
              on: { click: _vm.downloadFile }
            },
            [
              _c("input", {
                style: _vm.existFileData ? { cursor: "pointer" } : null,
                attrs: { type: "text", title: _vm.originalName, disabled: "" },
                domProps: { value: _vm.originalName }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "posAb",
              staticStyle: { right: "0", top: "6px", background: "none" },
              style:
                !_vm.existFileData || _vm.disabled ? { display: "none" } : null,
              on: { click: _vm.deleteAttachment }
            },
            [
              _c("img", {
                attrs: {
                  src: require("../images/btn_close.png"),
                  alt: "파일 삭제 버튼"
                }
              })
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37d95ab9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37d95ab9","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey2/components/SurveyAttachmentFamily.vue
// module id = null
// module chunks = 